// getComparisonRows.js

export function getComparisonRows(apiDataTrue, apiData, modifications = {}) {
  const rows = [];

  const truthData = apiDataTrue.data || {};
  const realData = apiData.data || {};

  const allKeys = Array.from(
    new Set([...Object.keys(truthData), ...Object.keys(realData)])
  ).filter((key) => key !== "market");

  allKeys.forEach((key) => {
    const truthEntry = truthData[key];
    const realEntry = realData[key];

    const expectedValue = truthEntry instanceof Object ? truthEntry.value : truthEntry;
    const fieldType = truthEntry instanceof Object ? truthEntry.fieldType : "N/A";
    const actualValue = realEntry;

    let passFail;

    if (!(key in truthData)) {
      // Key only in real beacon
      passFail = "Extra";
    } else if (!(key in realData)) {
      passFail = "Missing";
    } else if (actualValue === "") {
      passFail = "Fail";
    } else if (fieldType === "Dynamic") {
      const matches = String(expectedValue).match(/\[(.*?)\]/);
      if (matches && matches[1]) {
        const valuesArr = matches[1].split(",").map((val) => val.trim());
        const actual = String(actualValue).trim();
        if (valuesArr.length === 1) {
          passFail = actual !== "" ? "Pass" : "Fail";
        } else {
          passFail = valuesArr.includes(actual) ? "Pass" : "Fail";
        }
      } else {
        passFail = "Pass";
      }
    } else {
      // Handle boolean comparison (case-insensitive)
      const expectedStr = String(expectedValue).toLowerCase();
      const actualStr = String(actualValue).toLowerCase();
      
      // Check if both values are boolean-like
      const booleanValues = ['true', 'false'];
      if (booleanValues.includes(expectedStr) && booleanValues.includes(actualStr)) {
        passFail = expectedStr === actualStr ? "Pass" : "Fail";
      } else {
        passFail = expectedValue === actualValue ? "Pass" : "Fail";
      }
    }

    // Manual override
    if (modifications[key] !== undefined) {
      passFail = modifications[key];
    }

    rows.push({
      variableName: key,
      expectedValue: key in truthData ? expectedValue : "",
      actualValue: key in realData ? actualValue : "",
      passFail,
      fieldType: key in truthData ? fieldType : "N/A",
    });
  });

    // Sort: custom_attributes first (alphabetical), then others (alphabetical)
    rows.sort((a, b) => {
      const isCA_A = a.variableName.startsWith("data.custom_attributes.");
      const isCA_B = b.variableName.startsWith("data.custom_attributes.");
  
      if (isCA_A && !isCA_B) return -1;
      if (!isCA_A && isCA_B) return 1;
  
      return a.variableName.localeCompare(b.variableName);
    });
  
    return rows;
}
